class InstallGuide extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.section-install-guide__item'));
    this.triggers = Array.from(this.querySelectorAll('.section-install-guide__step-trigger'));
    this.panels = Array.from(this.querySelectorAll('.section-install-guide__panel'));
    this.mobileQuery = window.matchMedia('(max-width: 749px)');

    this.bindTriggers();
    this.bindScrollSpy();
    this.mobileQuery.addEventListener('change', () => this.bindScrollSpy());

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      window.addEventListener('shopify:section:load', this.setActive.bind(this, 0));
    }
  }

  setActive(index) {
    this.items.forEach((item, i) => {
      const isActive = i === index;
      item.classList.toggle('active', isActive);
      const trigger = this.triggers[i];
      if (trigger) trigger.setAttribute('aria-current', String(isActive));
    });

    const activeItem = this.items[index];
    if (activeItem) this.restartGifs(activeItem);
  }

  restartGifs(item) {
    // GIFs with a finite loop count (baked into the file) stop after playing once and
    // can't be told to loop via HTML/CSS. Reassigning src forces the browser to
    // reload and replay the animation from its first frame.
    item.querySelectorAll('img[data-gif]').forEach((img) => {
      const src = img.src;
      img.src = '';
      img.src = src;
    });
  }

  bindTriggers() {
    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener('mouseenter', () => {
        if (this.mobileQuery.matches) return;
        this.setActive(index);
      });
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.setActive(index);
      });
    });
  }

  bindScrollSpy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (!this.mobileQuery.matches || !('IntersectionObserver' in window)) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = this.panels.indexOf(entry.target);
          if (index > -1) this.setActive(index);
        });
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
    );

    this.panels.forEach((panel) => this.observer.observe(panel));
  }
}

if (!customElements.get('install-guide')) customElements.define('install-guide', InstallGuide);
